import React from "react";
import type { ViewComponent } from "@frui.ts/views";
import { observer } from "mobx-react-lite";
import { registerView } from "@frui.ts/views/dist";
import CardReturnListViewModel from "../../../../viewModels/finance/bankExports/cardReturns/cardReturnListViewModel";
import BankExportListView from "../bankExportListView";

const CardReturnListView: ViewComponent<CardReturnListViewModel> = observer(({ vm }) => {
  return <BankExportListView vm={vm} />;
});

registerView(CardReturnListView, CardReturnListViewModel);
